import { createRequest } from '@shared/services';

interface PostCartCalculatePayload {
    subdivision?: string;
    coupon_id?: string;
    shipping_profile_id: string;
}

export async function postCartCalculate(payload: PostCartCalculatePayload) {
    const request = createRequest<PostCartCalculateResponse>({
        url: '/cart/calculate',
        method: 'POST',
        withAuthorization: true,
        data: payload,
    });

    return request.execute();
}
